import { render, staticRenderFns } from "./BatchAdTask.vue?vue&type=template&id=f6d5bd80&scoped=true"
import script from "./BatchAdTask.vue?vue&type=script&lang=js"
export * from "./BatchAdTask.vue?vue&type=script&lang=js"
import style0 from "./BatchAdTask.vue?vue&type=style&index=0&id=f6d5bd80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6d5bd80",
  null
  
)

export default component.exports